import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import { RiCloseLine, RiMenu3Line } from "react-icons/ri";
import logo from "../../images/logo.png";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const navCloseOnClick = () => {
    setToggleMenu(false);
  };

  return (
    <header className={styles.navbar}>
      <div className={styles["navbar-left"]}>
        <Link className={styles["navbar-logo"]} to="/" onClick={navCloseOnClick}>
          <Image src={logo} alt="Encycdata" />
        </Link>
        <nav className={styles["navbar-links"]}>
        <Link className={styles["navbar-link"]} to="/products" onClick={navCloseOnClick}>
          Products
        </Link>
        <Link className={styles["navbar-link"]} to="/itservices" onClick={navCloseOnClick}>
          Consulting
        </Link>
        <Link className={styles["navbar-link"]} to="/staffing" onClick={navCloseOnClick}>
          Staffing
        </Link>
        <Link className={styles["navbar-link"]} to="/aboutus" onClick={navCloseOnClick}>
          Company
        </Link>
        <Link className={styles["navbar-link"]} to="/careers" onClick={navCloseOnClick}>
          Careers
        </Link>
        </nav>
      </div>

      <button
        type="button"
        className={styles["navbar-menu"]}
        aria-label="Toggle menu"
        onClick={() => setToggleMenu(!toggleMenu)}
      >
        {toggleMenu ? <RiCloseLine size={24} /> : <RiMenu3Line size={24} />}
      </button>

      {toggleMenu && (
        <div className={styles["navbar-menu_container"]}>
          <Link className={styles["navbar-menu_link"]} to="/products" onClick={navCloseOnClick}>
            Products
          </Link>
          <Link className={styles["navbar-menu_link"]} to="/itservices" onClick={navCloseOnClick}>
            Consulting
          </Link>
          <Link className={styles["navbar-menu_link"]} to="/staffing" onClick={navCloseOnClick}>
            Staffing
          </Link>
          <Link className={styles["navbar-menu_link"]} to="/aboutus" onClick={navCloseOnClick}>
            Company
          </Link>
          <Link className={styles["navbar-menu_link"]} to="/careers" onClick={navCloseOnClick}>
            Careers
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
